import React, { createContext, useState, useMemo } from 'react';
import { FeedData } from '~/services/home/contracts';

type NextBestActionContextType = {
  data: FeedData | null;
  setData: React.Dispatch<React.SetStateAction<FeedData | null>>;
};

const defaultContext: NextBestActionContextType = {
  data: null,
  setData() {}
};

const NextBestActionContext =
  createContext<NextBestActionContextType>(defaultContext);

export function NextBestActionContextProvider(props: React.PropsWithChildren) {
  const [data, setData] = useState<FeedData | null>(defaultContext.data);

  const value = useMemo<NextBestActionContextType>(
    () => ({ data, setData }),
    [data]
  );

  return (
    <NextBestActionContext.Provider value={value}>
      {props.children}
    </NextBestActionContext.Provider>
  );
}

export default NextBestActionContext;
